import {useLocation, useNavigate, useParams} from "react-router-dom";
import { useTranslation } from "react-i18next";
import { useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import routes from "../../../../../Routes/routes";

/**
 * @Email : kpozos@ibl.mx
 * @Author: Karen Yunuen Pozos Arias
 * @JobTitle: Full Stack Developer
 *
 * Description:
 * This hook (CommonMainDetailsApp) provides common state and logic
 * used in contractor-related detail pages, such as for displaying or modifying
 * employees, documents, vehicles, and more.
 */

export const CommonMainDetailsApp = () => {
    const dispatch = useDispatch(); // Redux dispatch function
    const params = useParams(); // Get route parameters (e.g., contractor ID from the URL)
    const navigate = useNavigate(); // Navigation handler for routing
    const { t } = useTranslation(); // Translation function for internationalization
    const location = useLocation();
    const DEV = useSelector((state) => state?.CommonsSlice?.development); // Development mode flag from Redux
    const { permission } = useSelector((state) => state.authenticatioauthennSlice); // User permissions from Redux

    // Retrieve contractor ID from sessionStorage
    const [contractorId, setContractorId] = useState(sessionStorage.getItem('contractorId'));
    const [supplierId, setSupplierId] = useState(sessionStorage.getItem('supplierId'));

    // State to control visibility of delete confirmation modal
    const [deleteElementShow, setDeleteElementShow] = useState(false);

    // State variables to hold different entity data
    const [elementDetails, setElementDetails] = useState(); // General element information
    const [elementEmployees, setElementEmployees] = useState(); // Associated employees
    const [elementDocuments, setElementDocuments] = useState(); // Associated documents
    const [elementVehicles, setElementVehicles] = useState(); // Associated vehicles
    const [workShiftsList, setWorkShiftsList] = useState([]); // Work shift options
    const [customizedList, setCustomizedList] = useState([]); // Custom data, could be used for select fields or filters
    /**
     * Transforms an array of user objects into a format suitable for dropdowns or UI display
     * @param {Array} tras - Array of user objects
     * @returns {Array} - Transformed array with 'label' and 'id'
     */
    const userDataTransform = (tras) => {
        return tras?.map((item) => {
            return {
                label:
                    (item?.name || '') +
                    ' ' +
                    (item?.lastName || '') +
                    (item?.secondLastName ? ' ' + item?.secondLastName : ''),
                id: item?.id,
            };
        });
    };


    // Return all variables and functions to be used in a component
    return {
        t,
        dispatch,
        navigate,
        DEV,
        permission,
        params,
        contractorId,
        supplierId,
        userDataTransform,
        deleteElementShow,
        setDeleteElementShow,
        elementDetails,
        setElementDetails,
        elementEmployees,
        setElementEmployees,
        elementDocuments,
        setElementDocuments,
        elementVehicles,
        setElementVehicles,
        workShiftsList,
        setWorkShiftsList,
        customizedList,
        setCustomizedList,
    }
};
